export default "__VITE_ASSET__DBOniIxw__"